import { call, put, select, fork } from 'redux-saga/effects';

import addOnsService from 'services/addOnsService';
import discountsService from 'services/discountsService';
import profitItemsService from 'services/profitItemsService';
import quoteService from 'services/quoteService';

import { getGroupId } from 'store/session/selectors';

import {
  fetchAddOns,
  fetchProfitItems,
  fetchDiscounts,
  fetchGlobalExpediteOptions,
} from './actions';

export function* fetchEntities() {
  yield fork(handleFetchAddOns);
  yield fork(handleFetchDiscounts);
  yield fork(handleFetchProfitItems);
}

function* handleFetchAddOns() {
  try {
    const groupId = yield select(getGroupId);
    const addOns = yield call(addOnsService.list, groupId);
    yield put(fetchAddOns.success({ addOns }));
  } catch (error) {
    yield put(fetchAddOns.error(error));
  }
}

function* handleFetchProfitItems() {
  try {
    const groupId = yield select(getGroupId);
    const profitItems = yield call(profitItemsService.list, groupId);
    yield put(fetchProfitItems.success({ profitItems }));
  } catch (error) {
    yield put(fetchProfitItems.error(error));
  }
}

function* handleFetchDiscounts() {
  try {
    const groupId = yield select(getGroupId);
    const discounts = yield call(discountsService.list, groupId);
    yield put(fetchDiscounts.success({ discounts }));
  } catch (error) {
    yield put(fetchDiscounts.error(error));
  }
}

export function* watchFetchGlobalExpediteOptions() {
  try {
    const groupId = yield select(getGroupId);
    const globalExpediteOptions = yield call(
      quoteService.getGlobalExpediteOptions,
      groupId,
    );
    yield put(fetchGlobalExpediteOptions.success({ globalExpediteOptions }));
  } catch (error) {
    console.error('FAILED TO FETCH GLOBAL EXPEDITE OPTIONS', error);
  }
}
